import ActionColumnComponent from "../../../disaster/components/ActionColumn/ActionColumn";

export const getAllColumns = (viewModal, updateModal, deleteRecord) => {
  const actionColumn = ActionColumnComponent({
    viewModal,
    updateModal,
    deleteRecord,
  });

  return {
    "Holiday Arrangements": [
      {
        title: "Holiday Arrangements",
        dataIndex: "Holiday Arrangements",
        key: "Holiday Arrangements",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],

};
};